import { Box, Image } from "@chakra-ui/react";
import lantern from "../images/lantern.png";

/**
 * @description 燈籠
 * @returns {JSX.Element}
 */
const Lantern = () => {
  return (
    <Box
      pointerEvents={"none"}
      position={"absolute"}
      right={"-4rem"}
      top={0}
      display={{ base: "none", lg: "block" }}
    >
      <Image src={lantern} />
    </Box>
  );
};

export default Lantern;
